<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
            >
            <el-breadcrumb-item>海外事务管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row :gutter="16">
            <el-col :span="24">
                <!-- 海外机构管理 -->
                <el-card style="margin-top: 15px">
                    <el-row class="title_row">
                        <el-col>
                            <span class="title_class">赛区机构管理</span>
                        </el-col>
                    </el-row>
                    <el-row :gutter="30" style="margin-top: 34px">
                        <el-col
                            :span="6"
                            v-for="(item, i) of overseasManagementList"
                            v-bind:key="i"
                        >
                            <tool :item="item" :index="i"></tool>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="16">
            <el-col :span="24">
                <!-- 海外机构管理 -->
                <el-card style="margin-top: 15px">
                    <el-row class="title_row">
                        <el-col>
                            <span class="title_class">操作管理</span>
                        </el-col>
                    </el-row>
                    <el-row :gutter="30" style="margin-top: 34px">
                        <el-col
                            :span="6"
                            v-for="(item, i) of overseasDataList"
                            v-bind:key="i"
                        >
                            <tool :item="item" :index="i"></tool>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="16">
            <el-col :span="24">
                <!-- 全球赛邀请 -->
                <el-card style="margin-top: 15px">
                    <el-row class="title_row">
                        <el-col>
                            <span class="title_class">全球赛Offer</span>
                        </el-col>
                    </el-row>
                    <el-row :gutter="30" style="margin-top: 34px">
                        <el-col
                            :span="6"
                            v-for="(item, i) of globalInviteList"
                            v-bind:key="i"
                        >
                            <tool
                                :item="item"
                                :index="i"
                                @showPop="handleShowPop"
                            ></tool>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="16">
            <el-col :span="24">
                <!-- 海外机构管理 -->
                <el-card style="margin-top: 15px">
                    <el-row class="title_row">
                        <el-col>
                            <span class="title_class">网站预留信息管理</span>
                        </el-col>
                    </el-row>
                    <el-row :gutter="30" style="margin-top: 34px">
                        <el-col
                            :span="6"
                            v-for="(item, i) of list"
                            v-bind:key="i"
                        >
                            <tool :item="item" :index="i"></tool>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>

        <!-- 生成 Offer Code 弹窗 -->
        <el-dialog
            title="生成Offer Code"
            :visible.sync="offerCodeDialogVisible"
            width="420px"
            @close="offerCodeDialogClose"
        >
            <el-form label-width="80px">
                <el-form-item label="数量">
                    <el-input
                        v-model="offerCodeNum"
                        placeholder="请输入生成数量"
                        clearable
                        @keyup.enter.native="submitOfferCode"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="offerCodeDialogVisible = false"
                    >取 消</el-button
                >
                <el-button
                    type="primary"
                    :loading="offerCodeSubmitting"
                    @click="submitOfferCode"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { createOfferCode } from '@/http/api'

export default {
  data () {
    return {
      activeName: 'first',
      // 生成 Offer Code 弹窗
      offerCodeDialogVisible: false,
      offerCodeNum: '',
      offerCodeSubmitting: false,
      overseasManagementList: [
        {
          icon: 'icon-baoming',
          rightTitle: '海外组委会申请信息',
          rightDesc: '可查看、审核组委会申请信息',
          path: '/overseas_committee_applyfor',
          menuTag: '3',
          authorityFlag: this.$chnEngStatusCode.system_competition_management
        },
        {
          icon: 'icon-ziyuan1',
          rightTitle: '海外组委会管理',
          rightDesc: '可新增、修改海外组委会信息',
          path: '/system_data_Management/system_competition_management?overseas=1',
          menuTag: '1',
          authorityFlag: this.$chnEngStatusCode.system_competition_management
        },
        {
          icon: 'icon-jigou1',
          rightTitle: '海外机构负责人',
          rightDesc: '可新增、修改海外机构负责人信息',
          path: '/c_data_Management/c_player_registInfo?overseas=1',
          menuTag: '2',
          authorityFlag: this.$chnEngStatusCode.system_competition_management
        }
      ],
      overseasDataList: [
        {
          icon: 'icon-duihuanma',
          rightTitle: '海外兑换码管理',
          rightDesc: '可新增、修改海外兑换码信息',
          path: '/product_Management/b_exchange_code_management',
          menuTag: '3',
          authorityFlag: this.$chnEngStatusCode.system_competition_management
        },
        {
          icon: 'icon-shenhetongguo',
          rightTitle: '兑换码申请记录',
          rightDesc: '可查看、审核赛事兑换码申请',
          path: '/overseas_code_applyfor',
          menuTag: '2',
          authorityFlag: this.$chnEngStatusCode.system_competition_management
        },
        {
          icon: 'icon-shenqingguanli',
          rightTitle: '海外联系我们管理',
          rightDesc: '可新增、修改、删除海外联系我们信息',
          path: '/overseas_contact_us_management',
          menuTag: '4',
          authorityFlag: this.$chnEngStatusCode.system_competition_management
        }
      ],
      globalInviteList: [
        {
          icon: 'icon-youhuiquan',
          rightTitle: 'Offer Code',
          rightDesc: '生成全球赛Offer Code',
          showPop: true, // 点击弹窗生成，不跳路由
          menuTag: '7',
          authorityFlag: this.$chnEngStatusCode.system_competition_management
        },
        {
          icon: 'icon-baoming',
          rightTitle: '报名列表',
          rightDesc: '通过全球赛Offer邀请的选手列表',
          path: '/national_overseas_management?type=3',
          menuTag: '8',
          authorityFlag: this.$chnEngStatusCode.system_competition_management
        }
      ],
      list: [
        {
          icon: 'icon-saishi',
          rightTitle: '全球赛报名信息',
          rightDesc: 'Global Finals-Registration',
          path: '/national_overseas_management',
          menuTag: '4',
          authorityFlag: this.$chnEngStatusCode.system_competition_management
        },
        {
          icon: 'icon-saishi',
          rightTitle: '全球总决赛快速咨询',
          rightDesc: 'Global Finals-Quick Inquiry',
          path: '/national_overseas_management?type=2',
          menuTag: '6',
          authorityFlag: this.$chnEngStatusCode.system_competition_management
        },
        {
          icon: 'icon-shenqingguanli',
          rightTitle: 'Join us咨询客户',
          rightDesc: 'Contact Us-Cooperation Application',
          path: '/overseas_contact_us_management',
          menuTag: '5',
          authorityFlag: this.$chnEngStatusCode.system_competition_management
        }
      ]

    }
  },
  created () {
    this.getData()
  },
  methods: {
    handleClick (tab, event) {
      if (tab._props.name === 'first') {
        // console.log('11111')
        this.$refs.directRef.initCharts()
      } else {
        // console.log('22222')
        this.$refs.directRef.initCharts()
      }
    },
    racingToolClicked (path) {
      if (path) {
        this.$router.push({ path })
      }
    },
    // tool 组件点击带 showPop 的卡片时触发（目前仅「Offer Code」）
    handleShowPop (item) {
      if (item && item.rightTitle === 'Offer Code') {
        this.offerCodeNum = ''
        this.offerCodeDialogVisible = true
      }
    },
    // 生成 Offer Code：传 num，接口成功后关闭弹窗
    submitOfferCode () {
      const num = String(this.offerCodeNum || '').trim()
      if (!num) return this.$message.warning('请输入数量')
      if (!/^[1-9]\d*$/.test(num)) return this.$message.warning('数量必须为大于0的整数')
      if (this.offerCodeSubmitting) return
      this.offerCodeSubmitting = true
      createOfferCode({ num: Number(num) }).then(res => {
        if (res.code === 200) {
          this.$message.success('生成成功')
          this.offerCodeDialogVisible = false
        } else {
          this.$message.error(res.msg || '生成失败')
        }
      }).catch(() => {
        // 异常提示由请求拦截器统一处理
      }).finally(() => {
        this.offerCodeSubmitting = false
      })
    },
    offerCodeDialogClose () {
      this.offerCodeNum = ''
      this.offerCodeSubmitting = false
    },
    getData () {
    }
  }
}
</script>

<style lang="less" scoped>
.real-time-backview {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .real-time-item {
        width: 50%;
        display: flex;
        margin-bottom: 20px;
        flex-direction: column;
        .real-time-title {
            width: 100%;
            font-size: 14px;
            color: #333;
            margin-bottom: 8px;
        }
        .real-time-desc {
            width: 100%;
            font-size: 24px;
            color: #1e96f1;
            span {
                font-size: 14px;
                color: #333;
            }
        }
    }
}
.racing-tool-back {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
}

// .racing-tool-leftimg {
//   width: 50px;
//   height: 60px;
//   margin-right: 5px;
// }

// .racing-tool-right {
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   font-size: 16px;
//   color: rgb(107, 107, 107);
// }
// .data-tool-leftimg {
//   width: 60px;
//   height: 60px;
//   border-radius: 10px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin-right: 5px;
// }
// .data-tool-img {
//   width: 35px;
//   height: 35px;
//   filter: grayscale(100%) brightness(0%) invert(100%);
// }

// .racing-tool-desc {
//   font-size: 12px;
// }
.redcolor {
    color: red;
}
.data-statistics-title {
    font-size: 14px;
    color: rgb(107, 107, 107);
}
.data-statistics-desc {
    font-size: 18px;
    color: rgb(65, 65, 65);
    font-weight: 900;
}
</style>
